<template>
  <el-container v-title data-title="食堂综合配置" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>食堂管理</el-breadcrumb-item>
                <el-breadcrumb-item>食堂综合配置</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="名称">
                  <el-input v-model="searchForm.name" placeholder="名称"></el-input>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getSchoolList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="name" label="学校" width="250"></el-table-column>
          <el-table-column prop="canteenStartOfWeekName" label="每周起始日" width="91"></el-table-column>
          <el-table-column prop="canteenStartOfMonthName" label="每月起始日" width="91"></el-table-column>
          <el-table-column prop="canteenStartWeekdayForOrderName" label="每周订餐起始日" width="119"></el-table-column>
          <el-table-column prop="canteenEndWeekdayForOrderName" label="每周订餐结束日" width="119"></el-table-column>
          <el-table-column prop="canteenStartTimeForOrder" label="起始日订餐开始时间" width="100"></el-table-column>
          <el-table-column prop="canteenEndTimeForOrder" label="结束日订餐结束时间" width="100"></el-table-column>
          <el-table-column prop="yuanOfCanteenCredit" :formatter="yuanOfCanteenCreditFormatter" label="赊账额度" width="90"></el-table-column>
          <!-- <el-table-column prop="canteenSchoolAccountBalance" :formatter="canteenSchoolAccountBalanceFormatter" label="学校可用额" width="100"></el-table-column> -->
          <el-table-column prop="canteenSchoolIncreaseAccountBalance" :formatter="canteenSchoolIncreaseAccountBalanceFormatter" label="学校增值账户可用额" width="100"></el-table-column>
          <el-table-column prop="canteenSchoolRecycleAccountBalance" :formatter="canteenSchoolRecycleAccountBalanceFormatter" label="学校回收账户可用额" width="100"></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button v-if="['1'].indexOf(userInfo.userType) != -1" type="text" @click="openModifyDialog(scope.row)">修改</el-button>
              <el-button type="text" @click="openCanteenIncreaseDialog(scope.row)">增值</el-button>
              <el-button type="text" @click="openCanteenReductionDialog(scope.row)">反增值</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getSchoolList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（修改） -->
      <el-dialog
        title="修改"
        :visible.sync="modifyDialogVisible"
        width="360px"
        :before-close="handleClose">
        <el-form ref="modifyForm" :model="modifyData" :rules="rules" label-width="140px">
          <el-form-item label="每周起始日" :required="true" prop="canteenStartOfWeek">
            <el-select v-model="modifyData.canteenStartOfWeek" placeholder="请选择每周起始日">
              <el-option label="周一" value="1"></el-option>
              <el-option label="周日" value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="每月起始日" :required="true" prop="canteenStartOfMonth">
            <el-input-number :min="1" :max="28" v-model="modifyData.canteenStartOfMonth" style="width: 160px"></el-input-number> 号
          </el-form-item>
          <el-form-item label="每周订餐起始日" :required="true" prop="canteenStartWeekdayForOrder">
            <el-select v-model="modifyData.canteenStartWeekdayForOrder" placeholder="请选择每周订餐起始日">
              <el-option label="周一" value="1"></el-option>
              <el-option label="周二" value="2"></el-option>
              <el-option label="周三" value="3"></el-option>
              <el-option label="周四" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="每周订餐结束日" :required="true" prop="canteenEndWeekdayForOrder">
            <el-select v-model="modifyData.canteenEndWeekdayForOrder" placeholder="请选择每周订餐结束日">
              <el-option label="周二" value="2"></el-option>
              <el-option label="周三" value="3"></el-option>
              <el-option label="周四" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="起始日订餐开始时间" :required="true" prop="canteenStartTimeForOrder">
            <el-time-select
              v-model="modifyData.canteenStartTimeForOrder"
              :picker-options="{start:'00:00',step:'00:10',end:'23:59'}"
              placeholder="起始日订餐开始时间" style="width: 180px">
            </el-time-select>
          </el-form-item>
          <el-form-item label="结束日订餐结束时间" :required="true" prop="canteenEndTimeForOrder">
            <el-time-select
              v-model="modifyData.canteenEndTimeForOrder"
              :picker-options="{start:'00:00',step:'00:10',end:'23:59'}"
              placeholder="结束日订餐结束时间" style="width: 180px">
            </el-time-select>
          </el-form-item>
          <el-form-item label="赊账额度" :required="true" prop="yuanOfCanteenCredit">
            <el-input-number :min="0" :max="3000" :precision="2" v-model="modifyData.yuanOfCanteenCredit" style="width: 160px"></el-input-number> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifySchool">修改</el-button>
            <el-button @click="modifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（增值） -->
      <el-dialog
        title="增值"
        :visible.sync="canteenIncreaseDialogVisible"
        width="320px"
        :before-close="handleClose">
        <el-form ref="canteenIncreaseForm" :model="canteenIncreaseData" :rules="rules" label-width="100px">
          <el-form-item label="增值金额" :required="true" prop="canteenIncreaseAmount">
            <el-input-number :min="0" :max="1000000" :precision="2" v-model="canteenIncreaseData.canteenIncreaseAmount" style="width: 160px"></el-input-number> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="canteenIncrease">增值</el-button>
            <el-button @click="canteenIncreaseDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（反增值） -->
      <el-dialog
        title="反增值"
        :visible.sync="canteenReductionDialogVisible"
        width="320px"
        :before-close="handleClose">
        <el-form ref="canteenReductionForm" :model="canteenReductionData" :rules="rules" label-width="100px">
          <el-form-item label="反增值金额" :required="true" prop="canteenReductionAmount">
            <el-input-number :min="0" :max="1000000" :precision="2" v-model="canteenReductionData.canteenReductionAmount" style="width: 160px"></el-input-number> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="canteenReduction">反增值</el-button>
            <el-button @click="canteenReductionDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {},
      modifyData: {},
      modifyDialogVisible: false,
      canteenIncreaseData: {
        canteenIncreaseAmount: 0
      },
      canteenIncreaseDialogVisible: false,
      canteenReductionData: {
        canteenReductionAmount: 0
      },
      canteenReductionDialogVisible: false,
      rules: {
        canteenStartOfWeek: [{ required: true, message: '请选择每周起始日', trigger: 'change' }],
        canteenStartOfMonth: [{ required: true, message: '请选择每月起始日', trigger: 'blur' }],
        canteenStartWeekdayForOrder: [{ required: true, message: '请输入每周订餐起始日', trigger: 'change' }],
        canteenEndWeekdayForOrder: [{ required: true, message: '请输入每周订餐结束日', trigger: 'change' }],
        canteenStartTimeForOrder: [{ required: true, message: '请选择起始日订餐开始时间', trigger: 'change' }],
        canteenEndTimeForOrder: [{ required: true, message: '请选择结束日订餐结束时间', trigger: 'change' }],
        yuanOfCanteenCredit: [{ required: true, message: '请输入赊账额度', trigger: 'blur' }],
        canteenIncreaseAmount: [{ required: true, message: '请输入增值金额', trigger: 'blur' }],
        canteenReductionAmount: [{ required: true, message: '请输入反增值金额', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getSchoolList()
    },
    openModifyDialog (schoolData) {
      this.modifyData = JSON.parse(JSON.stringify(schoolData))
      this.modifyDialogVisible = true
    },
    openCanteenIncreaseDialog (schoolData) {
      this.canteenIncreaseData.schoolId = schoolData.id
      this.canteenIncreaseData.canteenIncreaseAmount = 0
      this.canteenIncreaseDialogVisible = true
    },
    openCanteenReductionDialog (schoolData) {
      this.canteenReductionData.schoolId = schoolData.id
      this.canteenReductionData.canteenReductionAmount = 0
      this.canteenReductionDialogVisible = true
    },
    getSchoolList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          name: _this.searchForm.name,
          showCanteenSchoolBalance: '1',
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    yuanOfCanteenCreditFormatter (row) {
      let temp = ''
      if (row.yuanOfCanteenCredit >= 0) {
        temp = row.yuanOfCanteenCredit + '元'
      }
      return temp
    },
    // canteenSchoolAccountBalanceFormatter (row) {
    //   let temp = ''
    //   if (row.canteenSchoolAccountBalance >= 0) {
    //     temp = (row.canteenSchoolAccountBalance / 100).toFixed(2) + '元'
    //   }
    //   return temp
    // },
    canteenSchoolIncreaseAccountBalanceFormatter (row) {
      let temp = ''
      if (row.canteenSchoolIncreaseAccountBalance >= 0) {
        temp = (row.canteenSchoolIncreaseAccountBalance / 100).toFixed(2) + '元'
      }
      return temp
    },
    canteenSchoolRecycleAccountBalanceFormatter (row) {
      let temp = ''
      if (row.canteenSchoolRecycleAccountBalance >= 0) {
        temp = (row.canteenSchoolRecycleAccountBalance / 100).toFixed(2) + '元'
      }
      return temp
    },
    modifySchool () {
      console.log(this.modifyData.yuanOfCanteenCredit)
      let _this = this
      this.$refs['modifyForm'].validate((valid) => {
        if (valid) {
          _this.modifyData.canteenCredit = (_this.modifyData.yuanOfCanteenCredit * 100).toFixed(0)
          this.$axios.post(this.GLOBAL.host + '/school/update',
            _this.modifyData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.modifyDialogVisible = false
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                _this.getSchoolList()
                this.$refs['modifyForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    canteenIncrease () {
      let _this = this
      this.$refs['canteenIncreaseForm'].validate((valid) => {
        if (valid) {
          console.log(_this.canteenIncreaseData)
          // _this.canteenIncreaseData.canteenIncreaseAmount = (_this.canteenIncreaseData.canteenIncreaseAmount * 100).toFixed(0)
          this.$axios.post(this.GLOBAL.host + '/canteenAccount/canteenIncrease',
            // this.$qs.stringify(_this.canteenIncreaseData)
            this.$qs.stringify({
              schoolId: _this.canteenIncreaseData.schoolId,
              canteenIncreaseAmount: (_this.canteenIncreaseData.canteenIncreaseAmount * 100).toFixed(0)
            })
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.canteenIncreaseDialogVisible = false
                this.$message({
                  message: '增值成功',
                  type: 'success'
                })
                _this.getSchoolList()
                this.$refs['canteenIncreaseForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    canteenReduction () {
      let _this = this
      this.$refs['canteenReductionForm'].validate((valid) => {
        if (valid) {
          console.log(_this.canteenReductionData)
          // _this.canteenReductionData.canteenReductionAmount = (_this.canteenReductionData.canteenReductionAmount * 100).toFixed(0)
          this.$axios.post(this.GLOBAL.host + '/canteenAccount/canteenReduction',
            // this.$qs.stringify(_this.canteenReductionData)
            this.$qs.stringify({
              schoolId: _this.canteenReductionData.schoolId,
              canteenReductionAmount: (_this.canteenReductionData.canteenReductionAmount * 100).toFixed(0)
            })
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.canteenReductionDialogVisible = false
                this.$message({
                  message: '反增值成功',
                  type: 'success'
                })
                _this.getSchoolList()
                this.$refs['canteenReductionForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  watch: {
    tableData () {
      this.tableData.forEach(school => {
        if (school.canteenCredit >= 0) {
          school.yuanOfCanteenCredit = school.canteenCredit / 100
        }
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/CanteenSettings.vue